import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { KineticHeading, FadeIn } from "@/components/motion/Reveal";
import { Eyebrow } from "@/components/ui-kit";
import { unsplashSrc, unsplashSrcSet } from "@/lib/img";

// NOTE: public/index.html carries a static copy of each page hero (see scripts/gen-shell.py).
// If you change eyebrow / title / subtitle / image props on a page, re-run that script.
export function PageHero({ eyebrow, titleLines, subtitle, image }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [0, 160]);

  return (
    <section ref={ref} className="relative flex h-[72svh] min-h-[520px] items-end overflow-hidden bg-charcoal">
      <motion.div style={{ y }} className="absolute inset-0">
        <img
          src={unsplashSrc(image, 1600, 62)}
          srcSet={unsplashSrcSet(image, [640, 768, 1280, 1600, 1920], 62)}
          sizes="100vw"
          alt=""
          fetchPriority="high"
          decoding="async"
          className="h-full w-full object-cover"
        />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-b from-charcoal/60 via-charcoal/50 to-charcoal/85" />
      <div className="relative mx-auto w-full max-w-8xl px-6 pb-16 lg:px-10 lg:pb-24">
        <FadeIn delay={0.1}>
          <Eyebrow dark>{eyebrow}</Eyebrow>
        </FadeIn>
        <h1 className="mt-7 max-w-4xl font-serif text-4xl font-normal leading-[1.06] tracking-tightish text-paper sm:text-5xl lg:text-[4rem]">
          <KineticHeading delay={0.12} stagger={0.08} lines={titleLines} />
        </h1>
        {subtitle && (
          <FadeIn delay={0.4}>
            <p className="mt-7 max-w-xl text-base leading-[1.8] text-paper/70">{subtitle}</p>
          </FadeIn>
        )}
      </div>
    </section>
  );
}
